module.exports = __webpack_public_path__ + "static/media/triple-sapphire-sevens.36a16295.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GameIcon/triple-sapphire-sevens.png
// module id = 1364
// module chunks = 1